import React from 'react';
// import PropTypes from 'prop-types';
import Layout from '../../components/layout'
import '../../styles/pages/tv-plan.css'

const propTypes = {};

const defaultProps = {};

export default class tvPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Layout>
        <div class="page-wrapper">
          
          <div class="fullscreen bg14" data-scroll-index="0">
    <div class="grediant-overlay opacity-3"></div>
    <div class="center-col white-text" id="home">
          <div class="container">
              <div class="row">
                  <div class="col-md-10 col-lg-8" data-aos="fade-up" data-aos-duration="600" data-aos-delay="500">
                      <div class="home-content">
                          <h1 class="large-heading">
                              <span class="font-weight-extralight">Are your TV media plans based on intuition?</span> <br/>
                          </h1>
                      </div>
                      <div class="section-header pt-50">
                            <h4>The media planning is simplified for the media buyers, and their value is therefore redirected towards their negotiation skills.</h4>
                        </div>
                  </div>
              </div>
          </div>
      </div>
</div>

<section class="about-us pt-5 pb-5" data-scroll-index="1">
        <div class="container">
            <div class="row">
               <div class="col-md-6 col-lg-12 mb-30">
                    <div class="section-header">
                        <h2 class="custom-font-color">What We Do</h2>
                    </div>
                    <div class="about-us-content">
                            <h4>Build your TV Media Plans Using Artificial Intelligence</h4>
                        <p> The first TV media planning optimisation solution</p>
                    </div>
               </div>
               
            </div>
        </div>
    </section>


<section class="bg-light pt-5 pb-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                        <div class="section-header">
                                <h2 class="custom-font-color">Why We Do</h2>
                            </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <div class="business_features_box p-4 mt-3">
                        <div class="business_features_details">
                            <div class="">
                                <h5 class="text-capitalize text-grediant">ROI</h5>
                            </div>
                            <p class="text-muted mb-0">We model realistic variables to compute true ROI</p>
                        </div>
                    </div>

                    <div class="business_features_box p-4 mt-3">
                        <div class="business_features_details">
                            <div class="">
                                <h5 class="text-capitalize text-grediant">Time</h5>
                            </div>
                            <p class="text-muted mb-0">We evaluate thousands of plans to identify your Best Plan</p>
                        </div>
                    </div>

                   
                </div>

                <div class="col-lg-6">
                        <div class="business_features_box p-4 mt-3">
                                <div class="business_features_icon">
                                    <i class="text_custom font-weight-bold mdi mdi-chemical-weapon"></i>
                                </div>
                                <div class="business_features_details">
                                    <div class="">
                                        <h5 class="text-capitalize text-grediant">Efficient Algorithms</h5>
                                    </div>
                                    <p class="text-muted mb-0">We harness both data as well as domain expertise</p>
                                </div>
                            </div>

                            
                    <div class="business_features_box p-4 mt-3">
                        <div class="business_features_details">
                            <div class="">
                                <h5 class="text-capitalize text-grediant">Optimization</h5>
                            </div>
                            <p class="text-muted mb-0">Our algorithm can optimize your TV plan basis reach, GRP, Search and Business KPI</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>


<section class="pt-5 pb-5 how-it-work" data-scroll-index="1">
    <div class="container">
        <div class="section-header">
            <h2 class="custom-font-color">How It Works</h2>
        </div>

        <div class="row">
                <div class="col-md-6 col-lg-4 " data-aos="zoom-in" data-aos-duration="300">
                  <div class="service-card border-img">
                    <div class="icon-img">
                        <i class="fa fa-expand fa-2x"></i>
                    </div>
                    <div class="service-body">
                      <h6 class="service-title">Campaign Brief</h6>
                      <p class="service-description">We start with your campaign brief understanding and TV plan constraints
                      </p>
                   
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-4 " data-aos="zoom-in" data-aos-duration="500">
                  <div class="service-card border-img">
                    <div class="icon-img">
                    <i class="fa fa-wrench fa-2x"></i>
                    </div>
                    <div class="service-body">
                      <h6 class="service-title">Optimizations</h6>
                      <p class="service-description">Our unique AI/ ML algorithm simulates thousands of scenarios</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-4 " data-aos="zoom-in" data-aos-duration="700">
                  <div class="service-card border-img">
                    <div class="icon-img">
                        <i class="fa fa-tasks fa-2x"></i>
                    </div>
                    <div class="service-body">
                      <h6 class="service-title">TV Plan</h6>
                      <p class="service-description">Our technology amplifies your team’s capability to create different scenarios basis different conditions in real time
                      </p>
                    </div>
                  </div>
                </div>
              
            </div>
    </div>
</section>
</div>
      </Layout>
    );
  }
}

 tvPlan.propTypes = propTypes;
 tvPlan.defaultProps = defaultProps;